var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthLayout',{scopedSlots:_vm._u([{key:"cardBody",fn:function(){return [_c('Login',{attrs:{"loading":_vm.loading},on:{"handleLogin":_vm.handleLogin}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }